module.exports = __webpack_public_path__ + "static/pop_yd.89b814a8.png";